<template>
  <div class="spa-form-pdf-page">
    <div v-if="!viewerUrl" class="spa-form-pdf-page__message">{{ errorMessage }}</div>
    <template v-else>
      <div v-if="isLoading" class="spa-form-pdf-page__loader">
        <div class="spa-form-pdf-page__spinner"></div>
        <div class="spa-form-pdf-page__loader-text">Loading PDF...</div>
      </div>
      <iframe
        :src="viewerUrl"
        class="spa-form-pdf-page__frame"
        title="Property Sale and Purchase Agreement"
        @load="onFrameLoaded"
      />
    </template>
  </div>
</template>

<script>
import JwtService from "@/core/services/jwt.service";

export default {
  name: "SpaFormPdf",
  data() {
    return {
      viewerUrl: "",
      errorMessage: "Unable to load SPA.",
      isLoading: true,
    };
  },
  created() {
    if (!JwtService.getToken()) {
      this.$router.push({ path: "/login" });
      return;
    }

    const token = this.$route.params.token;
    if (!token) {
      return;
    }

    const baseUrl = (process.env.VUE_APP_ADMIN_API_URL || "").replace(/\/?$/, "/");
    this.viewerUrl = `${baseUrl}api/listingspaformpdf/view/${encodeURIComponent(token)}?_=${Date.now()}`;
  },
  methods: {
    onFrameLoaded() {
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.spa-form-pdf-page {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: #f5f5f5;
  position: relative;
}

.spa-form-pdf-page__frame {
  width: 100%;
  height: 100vh;
  border: 0;
  display: block;
}

.spa-form-pdf-page__message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
}

.spa-form-pdf-page__loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  z-index: 2;
}

.spa-form-pdf-page__spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #d5d5d5;
  border-top-color: #00004d;
  border-radius: 50%;
  animation: spa-form-pdf-spin 0.8s linear infinite;
}

.spa-form-pdf-page__loader-text {
  margin-top: 14px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
}

@keyframes spa-form-pdf-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
